/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { Badge } from 'antd-mobile'
import { PickNoticeIco } from '@shared/Icon/EtcIcon'
import { isMobile } from 'react-device-detect'
import _ from 'lodash'
import useRootStore from '@store/useRootStore'
// css
import { BadgeStyle } from '@styles/base.style'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { NOTICE_CATEGORY } from '@v2/constants/common'
import { TopNoticeWrap, topNoticeY } from '../index.style'

interface TopNoticeBarProps {
  className?: string
}

const TopNoticeBar: React.FC<TopNoticeBarProps> = (props: TopNoticeBarProps) => {
  const { globalStore, componentStore, logStore } = useRootStore()
  const { className = '' } = props
  const { matchupNotices } = componentStore
  const [topNoticeWrapClass, setTopNoticeWrapClass] = useState('')
  const { body } = document
  const htmlElem = document.getElementsByTagName('html')[0]

  const scrollY = topNoticeY - 1

  const scrollEventHandler = () => {
    if (htmlElem.scrollTop > scrollY || body.scrollTop > scrollY) {
      setTopNoticeWrapClass('show')
    } else {
      setTopNoticeWrapClass('')
    }
  }

  useOnMount(() => {
    if (isMobile) {
      window.addEventListener('scroll', scrollEventHandler, true)
    }
  })

  useOnUnmount(() => {
    if (isMobile) {
      window.removeEventListener('scroll', scrollEventHandler, true)
    }
  })

  const onClickNoticeDetail = async () => {
    try {
      const result = await componentStore.fetchNotice({ id: matchupNotices[0].id })
      if (result.notice) {
        logStore.writeButtonLog({ pageId: 'b010', buttonId: '001', buttonDetails: _.toString(result.notice.id) }).catch(console.error)
        if (result.notice.category === NOTICE_CATEGORY.TIP) {
          componentStore.setTipDetail(result.notice)
          globalStore.setVisibleTipDetail(true)
        } else {
          componentStore.setNoticeDetail(result.notice)
          globalStore.setVisibleNoticeDetail(true)
        }

        result.notice.isVisibleMatchup = false // 제거를 위한 플래그
        componentStore.updateMatchupNotice(result.notice)
        await componentStore.createNoticeReadHistory({ id: result.notice.id })
      }
    } catch (err) {
      console.error(err)
    }
  }

  const getClassName = (): string => {
    const classNameList = ['cursor-pointer']
    if (className) {
      classNameList.push(className)
    }
    if (topNoticeWrapClass) {
      classNameList.push(topNoticeWrapClass)
    }
    return classNameList.join(' ')
  }

  return _.size(matchupNotices) === 0 ? null : (
    <TopNoticeWrap
      className={getClassName()}
      onClick={onClickNoticeDetail}
    >
      <div className="notice-ico">
        <PickNoticeIco/>
        <Badge text={_.size(matchupNotices) - 1} overflowCount={9} css={BadgeStyle}/>
      </div>
      <div className="notice-tit">
        <p className="tit">{matchupNotices[0].title}</p>
      </div>
    </TopNoticeWrap>
  )
}
export default observer(TopNoticeBar)
